function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "talk-bubbles-outline-badged",
  transform: "translate(-2 -1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11917",
  "data-name": "Path 11917",
  d: "M26.209,28.292a1.153,1.153,0,0,1-1.153,1.153H8.917c-.254,0-.5.231-.7.38L4.306,32.9V14.458a1.153,1.153,0,0,1,1.153-1.153h4.45V11H5.458A3.458,3.458,0,0,0,2,14.458V35.209a1.126,1.126,0,0,0,1.8.911l5.937-4.369H25.229a3.193,3.193,0,0,0,3.286-3.309v-1.3H26.209Z",
  transform: "translate(0 1.528)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11918",
  "data-name": "Path 11918",
  d: "M35.209,14.629V25.834l-4.035-3.147a1.153,1.153,0,0,0-.7-.242H14.458a1.153,1.153,0,0,1-1.153-1.153V7.458a1.153,1.153,0,0,1,1.153-1.153h9.8A8.635,8.635,0,0,1,24.58,4H14.458A3.458,3.458,0,0,0,11,7.458V21.292a3.458,3.458,0,0,0,3.458,3.458H30.079l5.51,4.277a1.128,1.128,0,0,0,1.81-.911V13.649a8.589,8.589,0,0,1-2.19.98Z",
  transform: "translate(1.375 0.458)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11919",
  "data-name": "Path 11919",
  d: "M36.528,6.764A5.764,5.764,0,1,1,30.764,1,5.764,5.764,0,0,1,36.528,6.764Z",
  transform: "translate(3.515)",
  fill: "#ac1ede"
}));

var SvgTalkBubblesOutlineBadged = function SvgTalkBubblesOutlineBadged(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38.043,
    height: 36.867,
    viewBox: "0 0 38.043 36.867",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTalkBubblesOutlineBadged, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/talk-bubbles-outline-badged.fc7e5b1c.svg";
export { ForwardRef as ReactComponent };